import React from "react";

function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 128 128"
    >
      <circle cx="64" cy="64" r="55" fill="#fff"></circle>
      <path
        fill="#522398"
        d="M64 122C32 122 6 96 6 64S32 6 64 6s58 26 58 58-26 58-58 58zm0-110c-28.7 0-52 23.3-52 52s23.3 52 52 52 52-23.3 52-52-23.3-52-52-52z"
      ></path>
      <path
        fill="#522398"
        d="M64 49c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10zm0-14c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zM64 102c-5.5 0-10-4.5-10-10V68c0-5.5 4.5-10 10-10s10 4.5 10 10v24c0 5.5-4.5 10-10 10zm0-38c-2.2 0-4 1.8-4 4v24c0 2.2 1.8 4 4 4s4-1.8 4-4V68c0-2.2-1.8-4-4-4z"
      ></path>
    </svg>
  );
}

export default InfoIcon;
